// extracted by mini-css-extract-plugin
module.exports = {"loadingIcon":"LoadingIcon__loadingIcon","spin":"LoadingIcon__spin"};